import React, {useEffect, useState} from 'react';
import {
  AppForm,
  AppFormField,
  AppFormSelectField,
  AppFormSubmitButton,
} from '../../../../../components/forms';
import {Column, Row} from '../../../../../components/layout';
import {DataValidationProps} from '../DataValidation';
import * as Yup from 'yup';
import * as fonts from '../../../../../util/fonts';

import './styles.scss';
import {get} from '../../../../../api/api';
import {uriGetBus} from '../../../../../api/endpoints';
import {addToWizard} from '../../../../../store/actions';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {colors} from './../../../../../util/colors';
import Header2 from '../../../../../components/headers/header2';
import {ApiResponse, ApiResponseArray} from '../../../../../util/utility';

function AddUser({
  setValid,
  valid,
  addToWizard,
  labels,
  messageLabels,
  wizard,
  nextStep,
}: DataValidationProps) {
  const [bu, setBu] = useState('');
  const [buOptions, setBuOptions] = useState<any[]>([]);

  const featureName = 'Register-AddUser';
  const validationSchema = Yup.object().shape({
    bu: Yup.string().required(messageLabels?.requiredField),
    cardNumber: Yup.string().max(20),
    otherEntity: Yup.string(),
    //phone: Yup.string().required().max(13).matches(new RegExp('^[0-9+]+$'), ''),
  });

  useEffect(() => {
    async function getBuOptions() {
      await get(uriGetBus(), false, 0, featureName)
        .then((response: ApiResponseArray | unknown) => {
          const res = response as ApiResponseArray;

          setBuOptions(
            res?.data?.items?.map((bu: any) => ({
              value: bu.id,
              label: bu.name,
            }))
          );
        })
        .catch((err: any) => {
          console.log('err', err);
        });
    }
    getBuOptions();
  }, []);

  const userContacts =
    wizard?.dataValidation?.currentUser?.email ||
    wizard?.dataValidation?.currentUser?.phone;

  const handleNoCard = () => {
    const dataValidation = {
      cardNumber: '',
      otherEntity: '',
      currentUser: {
        ...wizard?.dataValidation?.currentUser,
        contacts: {buId: bu, phone: ''},
      },
      selectedContact: '',
      selectedContactType: 'EMAIL',
      state: bu === 'noInsurance' ? 'NOT_CLIENT' : 'NOT_FOUND',
    };

    addToWizard({dataValidation});
    nextStep();
  };

  return (
    <Column className="add-contacts-container mt-5">
      <Header2 className="stepper-title mb-4 mt-2">
        {labels?.activationChoice_title}
      </Header2>
      <AppForm
        initialValues={{bu: '', cardNumber: '', phone: ''}}
        validationSchema={validationSchema}
        onSubmit={async (values: any, {validateForm}: any) => {
          const errors = await validateForm(values);
          if (Object.keys(errors).length > 0) {
            return;
          }

          const dataValidation = {
            cardNumber: values.cardNumber,
            otherEntity: values.otherEntity,
            currentUser: {
              ...wizard?.dataValidation?.currentUser,
              contacts: {buId: values.bu, phone: ''},
            },
            selectedContact: '',
            selectedContactType: 'EMAIL',
            state: values.bu === 'noInsurance' ? 'NOT_CLIENT' : 'NOT_FOUND',
          };

          addToWizard({dataValidation});
          nextStep();
        }}>
        <Row className="add-user-text-row">
          <Column>
            <p
              className="add-contacts-didnt-receive-question-text"
              style={{...fonts.ML}}>
              {labels?.activationChoice_subTitle}
            </p>
            <p
              className="add-contacts-didnt-receive-question-text-responsive"
              style={{...fonts.M}}>
              {labels?.activationChoice_subTitle}
            </p>
            <br />
            <p
              className="add-contacts-didnt-receive-question-text"
              style={{...fonts.ML}}>
              {labels?.activationChoice_underText}
            </p>
            <p
              className="add-contacts-didnt-receive-question-text-responsive"
              style={{...fonts.M}}>
              {labels?.activationChoice_underText}
            </p>
          </Column>
        </Row>
        <Row className="add-user-row">
          <AppFormSelectField
            showErrorMessage
            name={'bu'}
            //placeholder={labels?.activationChoice_dropdownPlaceholder}
            options={[
              {
                value: 'noInsurance',
                label: labels?.activationChoice_NoInsuranceText,
              },
              ...buOptions,
              {
                value: 'otherEntity',
                label: labels?.activationChoice_OtherEntityText,
              },
            ]}
            onChange={(value) => {
              setBu(value);
            }}
          />
        </Row>
        {bu !== '' && bu !== 'noInsurance' && bu !== 'otherEntity' && (
          <React.Fragment>
            <Row className="add-user-row">
              <AppFormField
                name={'cardNumber'}
                placeholder={
                  labels?.activationChoice_insuranceNumberPlaceholder
                }
              />
            </Row>
            <Row className="add-contacts-row app-center">
              <Column>
                <a
                  className="add-contacts-didnt-receive-question"
                  onClick={handleNoCard}
                  href=""
                  style={{...fonts.M, color: colors.blue}}>
                  {labels?.insuranceAndPhone_didntReveceiveCard}
                </a>
                {/* <p
                  className="add-contacts-didnt-receive-question-text"
                  style={{...fonts.M}}>
                  {labels?.insuranceAndPhone_didndReceivedText}
                </p> */}
              </Column>
            </Row>
          </React.Fragment>
        )}
        {bu !== '' && (
          <React.Fragment>
            {/* <hr className="add-contacts-hr" />
            <Row className="add-user-row">
              <AppFormField
                name="phone"
                placeholder={labels?.insuranceAndPhone_phoneNumberPlaceholder}
              />
            </Row> */}
          </React.Fragment>
        )}
        <Row className="insurance-validation-continue-button-row">
          <AppFormSubmitButton
            title={labels?.insuranceAndPhone_confirmButtonText}
            className="stepper-continue-button"
          />
        </Row>
      </AppForm>
    </Column>
  );
}

const mapDispatchToProps = (dispatch: any) => ({
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(connect(null, mapDispatchToProps)(AddUser));
